module.exports = __webpack_public_path__ + "static/img/rule.1abb94ea.png";